import { SimpleListItem } from "./SimpleListItem";

export class ListItem extends SimpleListItem {
    protected initialize(data: any) {
        data = "* " + data;
        super.initialize(data);
    }
}
